import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateHeroA(section, img, line, textLines, buttons) {

  // Inidividual tweens
  // Image
  let imgTween = img ? gsap.to(img, {
    duration: 0.8,
    opacity: 1,
    ease: "power1.in",
  }) : null;

  // Animated lines of text
  let textLinesTween = textLines ? gsap.to(textLines, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Vertical red line
  let lineTween = line ? gsap.to(line, {
    height: line.classList.contains("has-video") ? "280%" : "90%",
    opacity: 1,
    duration: 0.8,
    ease: "power1.out",
  }) : null;

  // Buttons div
  let buttonsTween = buttons ? gsap.to(buttons, {
    x: 0,
    opacity: 1,
    duration: 0.25,
  }) : null;

  // Timeline
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 90%",
    },
  });

  tl
    .add(imgTween)
    .addLabel("textStart")
    .add(textLinesTween, "textStart-=0.4")
    .add(lineTween, "textStart")
    .add(buttonsTween);
}